import { render, staticRenderFns } from "./LabelPage.vue?vue&type=template&id=065669af&scoped=true&"
import script from "./LabelPage.vue?vue&type=script&lang=js&"
export * from "./LabelPage.vue?vue&type=script&lang=js&"
import style0 from "./LabelPage.vue?vue&type=style&index=0&id=065669af&lang=scss&scoped=true&"
import style1 from "./LabelPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065669af",
  null
  
)

export default component.exports